<h4 mat-dialog-title>Modification propriétés.</h4>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit()" [formGroup]="editSvcCmpInputForm" style="margin-top: 20px">
  <mat-dialog-content class="mat__typography">
    <div fxLayout="column" fxLayoutGap="15px">
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>{{placeholderTitle}}</mat-label>
          <input formControlName="placeholder" matInput
                 matTooltip="{{placeholderText}}"
                 placeholder="{{placeholderText}}"
                 type="text" data-cy="input-scv-cmp-placeholder">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>{{tooltipTitle}}</mat-label>
          <input formControlName="tooltip" matInput
                 matTooltip="{{tooltipText}}"
                 placeholder="{{tooltipText}}"
                 type="text" data-cy="input-scv-cmp-tooltip">
        </mat-form-field>
      </div>
      <div>
        <p><mat-label class="mat-h4">Choisissez une des options ci-dessous pour alimenter la liste services / composantes : </mat-label></p>
        <mat-button-toggle-group name="entite" formControlName="entite" aria-label="entite">
          <mat-button-toggle value="{{entiteTypeEnum.dir}}">Services</mat-button-toggle>
          <mat-button-toggle value="{{entiteTypeEnum.cmp}}">Composantes</mat-button-toggle>
          <mat-button-toggle value="{{SVC_CMP}}">Services ou Composantes</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onNoClick()"
            mat-raised-button
            color="primary"
            type="button">
      Annuler
    </button>
    <button mat-raised-button
            cdkFocusInitial
            color="accent"
            type="submit">
      Sauvegarder
    </button>
  </mat-dialog-actions>
</form>

